import { render, staticRenderFns } from "./RequestChanges.vue?vue&type=template&id=63e02e27&scoped=true"
import script from "./RequestChanges.vue?vue&type=script&lang=js"
export * from "./RequestChanges.vue?vue&type=script&lang=js"
import style0 from "./RequestChanges.vue?vue&type=style&index=0&id=63e02e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e02e27",
  null
  
)

export default component.exports